import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './googleTags';

const GoogleTagManagerTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(pagePath);
  }, [location]);

  return null;
};

export default GoogleTagManagerTracker;
